// extracted by mini-css-extract-plugin
export default {"FlightChipGroup":"FlightChipGroup_FlightChipGroup__NmQ1Z","mobile_scroll_container_body":"FlightChipGroup_mobile_scroll_container_body__NGIxM"};